import { EmployeeExpenseReportSTO } from "../../models/employee-expense-reports/employee-expense-report-sto";
import { ExpenseReportDTO, ExpenseReportSTO } from "../../models/expense-reports";
import { BaseApiService } from "../base";
import { ListSortDirection, Sort } from "../../models/api/sort";
import { SaveResponse } from "../../models/api/save";

export class EmployeeExpenseReportsApiService extends BaseApiService<ExpenseReportDTO, EmployeeExpenseReportSTO> {
  constructor() {
    super({
      servicePath: "/EmployeeExpenseReports",
      loadItemsPath: "/GetEmployeeExpenseReports",
      saveItemsPath: "/SaveEmployeeExpenseReports",
    });
    this.defaultSort = [
      {
        name: "createdAt",
        direction: ListSortDirection.Ascending,
      } as Sort,
    ];
  }
}

export const submitExpenseReports = async (expenseReports: EmployeeExpenseReportSTO[]): Promise<SaveResponse> => {
  const apiService = new EmployeeExpenseReportsApiService();
  apiService.useSaveItemsPath("/SubmitExpenseReports");
  const response = apiService.saveItems([...expenseReports]);

  return response;
};

export const cancelExpenseReports = async (expenseReports: EmployeeExpenseReportSTO[]): Promise<SaveResponse> => {
  const apiService = new EmployeeExpenseReportsApiService();
  apiService.useSaveItemsPath("/CancelExpenseReports");
  const response = apiService.saveItems([...expenseReports]);

  return response;
};

export const markExpenseReportAsDrafts = async (expenseReports: EmployeeExpenseReportSTO[]): Promise<SaveResponse> => {
  const apiService = new EmployeeExpenseReportsApiService();
  apiService.useSaveItemsPath("/MarkExpenseReportsAsDraft");
  const response = apiService.saveItems([...expenseReports]);

  return response;
};
